import {FooterProps} from "./DeleteModal";
import React from "react";
import {useTranslation} from "react-i18next";
import {AlertCircleIcon} from "../../ui/icons";
import cn from "classnames";
import classes from "./EditorScenarioActivationMethodModal.module.css";
import Button from "../../ui/button";

function Header() {
  const {t} = useTranslation();

  return (
    <>
      <span>{t("components.EditScenarioActivationMethodModal.title")}</span>
    </>
  );
}

function Content({
  scenariosWithBranchesLeadsToCurrent,
}: {
  scenariosWithBranchesLeadsToCurrent: Array<{name: string; id: string}>;
}) {
  const {t} = useTranslation();

  let linksToCurrent = scenariosWithBranchesLeadsToCurrent.map((scenario) => scenario.name).join(", ");

  return (
    <>
      <span>{t("components.EditScenarioActivationMethodModal.content")}</span>
      <div className={cn(classes.warningWrapper)}>
        <AlertCircleIcon className={cn(classes.warning)} />
        <p> {t("components.EditScenarioActivationMethodModal.warningMessage")}</p>
      </div>
      <ul className={cn(classes.list)}>
        <li>
          <span>
            {" "}
            {t("components.EditScenarioActivationMethodModal.linksToCurrent")} {linksToCurrent}
          </span>
        </li>
      </ul>
    </>
  );
}
function Footer({onCancel, onConfirm, className, ...props}: FooterProps) {
  const {t} = useTranslation();

  return (
    <div className={cn(classes.footer, className)} {...props}>
      <Button color="secondary" onClick={onCancel}>
        {t("common.cancel")}
      </Button>
      <Button color="danger" onClick={onConfirm}>
        {t("common.change")}
      </Button>
    </div>
  );
}

const EditScenarioActivationMethodModal = {
  Header: Header,
  Content: Content,
  Footer: Footer,
};

export default EditScenarioActivationMethodModal;

